import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const ExchangeListTable = ({
  children,
  count,
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => (
  <Common.Table bordered>
    <thead>
      <tr>
        <Common.ThSortable
          orderBy={orderBy}
          order={order}
          field="_fromCurrency"
          handleOrderChange={handleOrderChange}
        >
          {t('exchange.fields.fromCurrency')}
        </Common.ThSortable>
        <Common.ThSortable
          orderBy={orderBy}
          order={order}
          field="_toCurrency"
          handleOrderChange={handleOrderChange}
        >
          {t('exchange.fields.toCurrency')}
        </Common.ThSortable>
        <Common.ThSortable
          orderBy={orderBy}
          order={order}
          field="date"
          handleOrderChange={handleOrderChange}
        >
          {t('exchange.fields.date')}
        </Common.ThSortable>

        <Common.ThSortable
          orderBy={orderBy}
          order={order}
          field="value"
          handleOrderChange={handleOrderChange}
        >
          {t('exchange.fields.value')}
        </Common.ThSortable>

        <th className="text-center">{t('common.actions')}</th>
      </tr>
    </thead>

    <tbody>
      {count === 0 && <Common.EmptyTable colSpan={10} />}
      {children}
    </tbody>
  </Common.Table>
);

export default translate()(ExchangeListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/components/list/ExchangeListTable.js